import React from "react";
import "./ReturnPolicy.css";

const ReturnPolicy = () => {
  return (
    <div className="return-policy-page">
      <div className="container">
        <div className="page-header">
          <h1>Returns Policy</h1>
          <p>
            At OMERTOOLS, we are committed to delivering high-quality products and exceptional customer service. Please take note of the following terms regarding our returns policy.
          </p>
        </div>

        <section className="policy-section">
          <h2>Change of Mind Returns</h2>
          <p>
            We do not accept change-of-mind returns, exchanges, or refunds on any products purchased from OMERTOOLS, unless required by applicable law. We encourage all customers to carefully review and inspect products before completing their purchase.
          </p>
        </section>

        <section className="policy-section">
          <h2>Faulty or Damaged Items</h2>
          <p>
            In the event that you receive a faulty or damaged item, please reach out to our customer service team. We will work with you to explore possible solutions, which may include repairs or replacements in accordance with your rights under Australian Consumer Law.
          </p>
        </section>

        <section className="policy-section">
          <h2>Warranty Matters</h2>
          <p>
            For warranty-related matters, please refer to the manufacturer's warranty policy included with your product, which may offer repair or replacement options.
          </p>
        </section>

        <section className="policy-section">
          <h2>Exceptions & Legal Rights</h2>
          <p>
            This policy does not override your statutory rights under Australian Consumer Law, including guarantees and warranties on faulty or misrepresented goods.
          </p>
          <p>
            If you believe a product is defective or does not meet your legal rights, please contact us at: Info@omertools.com.au
          </p>
        </section>

        <section className="policy-section">
          <h2>Disclaimer of Liability for Advice and Recommendations</h2>
          <p>
            Our team is here to assist you with product information and guidance. However, any advice, recommendations, or information provided by our staff is offered in good faith and for general informational purposes only.
          </p>
          <p>
            OMERTOOLS and its staff accept no liability for any loss, damage, or injury resulting from reliance on such advice or recommendations. Customers are responsible for verifying the suitability of products for their specific needs prior to purchase. Where necessary, we recommend seeking independent advice or professional consultation.
          </p>
          <p>
            By engaging with our team, you acknowledge and agree to this disclaimer.
          </p>
        </section>

        <section className="policy-section contact-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions or need assistance regarding your purchase or this policy, please contact our customer service team at:
          </p>
          <p>Email: Info@omertools.com.au</p>
          <p>Phone: (02) 9759 8833</p>
        </section>
      </div>
    </div>
  );
};

export default ReturnPolicy;
